import { Link } from "react-router-dom";

const socialLinks = [
  { icon: "ri-facebook-fill", label: "Facebook", href: "https://www.facebook.com/profile.php?id=100084434082725" },
  { icon: "ri-instagram-line", label: "Instagram", href: "https://www.instagram.com/sheldonmckenzie99" },
  { icon: "ri-youtube-fill", label: "YouTube", href: "https://www.youtube.com/@sheldonmckenzieministries" },
  { icon: "ri-twitter-x-line", label: "X (Twitter)", href: "#" },
  { icon: "ri-tiktok-fill", label: "TikTok", href: "#" },
  { icon: "ri-spotify-fill", label: "Spotify", href: "#" },
];

const footerLinks = [
  {
    title: "Medical",
    links: [
      { label: "Endocrinology", path: "/consultation" },
      { label: "Diabetes Care", path: "/consultation" },
      { label: "Thyroid Health", path: "/consultation" },
      { label: "Book Consultation", path: "/consultation" },
    ],
  },
  {
    title: "Ministry",
    links: [
      { label: "Sermons", path: "/ministry" },
      { label: "Events", path: "/ministry" },
      { label: "Devotionals", path: "/ministry" },
      { label: "Prayer Requests", path: "/contact" },
    ],
  },
  {
    title: "Store",
    links: [
      { label: "Books", path: "/store" },
      { label: "Audio & Sermons", path: "/store" },
      { label: "Supplements", path: "/store" },
      { label: "Digital Downloads", path: "/store" },
    ],
  },
  {
    title: "Connect",
    links: [
      { label: "About Dr. Sheldon Mckenzie", path: "/about" },
      { label: "Contact Us", path: "/contact" },
      { label: "Telehealth Info", path: "/consultation" },
      { label: "Newsletter", path: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-stone-100">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {footerLinks.map((col) => (
          <div key={col.title}>
            <h4 className="text-sm font-bold uppercase tracking-widest text-stone-800 mb-4 pb-2 border-b border-stone-300">
              <a href="#">{col.title}</a>
            </h4>
            <ul className="flex flex-col gap-2">
              {col.links.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.path}
                    className="text-sm text-stone-500 hover:text-amber-700 transition-colors cursor-pointer"
                    rel="nofollow"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom Section */}
      <div className="border-t border-stone-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <p
              className="text-base font-bold text-stone-800"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Dr. Sheldon Mckenzie
            </p>
            <p className="text-xs text-stone-400 tracking-wide mt-0.5">
              Healing through Faith &amp; Science
            </p>
          </div>
          <div className="flex items-center gap-3">
            {socialLinks.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-amber-50 text-amber-700 hover:bg-amber-700 hover:text-white transition-all cursor-pointer text-base"
              >
                <i className={s.icon} />
              </a>
            ))}
          </div>
          <p className="text-xs text-stone-400">
            &copy; {new Date().getFullYear()} Dr. Sheldon Mckenzie. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
